import { LocationStrategy } from '@angular/common';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IBaseModel } from '../models/base.model';
import { IIndicadorModel } from '../models/indicador.model';
import { BaseService } from './base.service';

@Injectable({
  providedIn: 'root',
})
export class IndicadorService extends BaseService {

  constructor(httpClient: HttpClient, locationStrategy: LocationStrategy) {
    super(httpClient, locationStrategy);
  }

  public obter(pesquisa: string, ativo: boolean, simplificado = false): Promise<IBaseModel<IIndicadorModel[]>> {
    let params = new HttpParams();
    params = params.append('pesquisa', pesquisa || '');

    if (ativo !== undefined) {
      params = params.append('ativo', ativo.toString());
    }

    if (simplificado) {
      params = params.append('simplificado', simplificado.toString());
    }

    return this.httpClient
      .get<IBaseModel<IIndicadorModel[]>>(`${this.apiBaseUrl}/indicador`, { params })
      .toPromise();
  }

  public async obterPorId(id: number): Promise<IBaseModel<IIndicadorModel>> {
    return this.httpClient
      .get<IBaseModel<IIndicadorModel>>(`${this.apiBaseUrl}/indicador/${id}`)
      .toPromise();
  }

  public async inserir(data: IIndicadorModel): Promise<IBaseModel<void>> {
    return this.httpClient
      .post<IBaseModel<void>>(`${this.apiBaseUrl}/indicador`, data)
      .toPromise();
  }

  public async atualizar(data: IIndicadorModel): Promise<IBaseModel<void>> {
    return this.httpClient
      .put<IBaseModel<void>>(`${this.apiBaseUrl}/indicador/${data.id}`, data)
      .toPromise();
  }

  public async reativar(id: number): Promise<IBaseModel<void>> {
    return this.httpClient
      .post<IBaseModel<void>>(`${this.apiBaseUrl}/indicador/${id}/reativar`, {})
      .toPromise();
  }

  public async inativar(id: number): Promise<IBaseModel<void>> {
    return this.httpClient
      .post<IBaseModel<void>>(`${this.apiBaseUrl}/indicador/${id}/inativar`, {})
      .toPromise();
  }

  public async excluir(id: number): Promise<IBaseModel<void>> {
    return this.httpClient
      .delete<IBaseModel<void>>(`${this.apiBaseUrl}/indicador/${id}/excluir`, {})
      .toPromise();
  }
}
